export const JOY_BRAND_NAME = 'Joy';
export const JOY_HELP_URL = 'https://help.withjoy.com/';
export const JOY_ABOUT_URL = 'https://withjoy.com/about/';
export const JOY_BROWSE_DESIGNS_URL = 'https://withjoy.com/wedding-website';
export const JOY_TERMS_URL = 'https://withjoy.com/eula/';
export const JOY_PRIVACY_URL = 'https://privacy.withjoy.com/';
export const DEFAULT_HOTEL_IMAGE = 'https://withjoy.com/assets/public/hotelselection/empty-hotel-item-v4.png';
export const DEFAULT_HOTEL_IMAGE_WIDE = 'https://withjoy.com/assets/public/hotelselection/empty-hotel-item-v2-wide.png';
export const HOTEL_IMAGE_PLACEHOLDER = 'https://withjoy.com/assets/public/travel/hotel-image-placeholder.jpg';
export const SWIPE_RIGHT_LOTTIE_URL = 'https://withjoy.com/assets/public/apps/travel/lotties/swipe_right_v1.json';
export const ANIMATED_BELL = 'https://withjoy.com/assets/public/apps/travel/lotties/bell.json';
export const ANIMATED_SUCCESS_CHECK = 'https://withjoy.com/assets/public/apps/travel/lotties/success-check.json';
export const DEFAULT_STAY_AREAS_IMAGE = 'https://withjoy.com/assets/public/travel/default-stay-zones.png';
